import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { ComponentsModule } from 'shared/components/components.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { AuthenticatedUserModule } from 'services/authenticatedUser/authenticatedUser.module';
import { FcpToastModule } from 'fc-ui-components';
import { NgxEchartsModule } from 'ngx-echarts';
import { catalogRedirectionGuard } from 'app/b2b-order/services/guards/catalog-redirection-guard.service';
import { authGuardFn } from '@auth0/auth0-angular';
import { signupStatusGuard } from 'shared/services/guards/signup-guard.service';
import { AdminGuard } from 'shared/services/guards/admin-guard.service';
import { userGuard } from 'shared/services/guards/user-guard.service';
import { UsercentricsComponent } from './shared/components/usercentrics/usercentrics.component';
import {
    adminPlatformLegacyCanMatchGuard,
    adminPlatformV2CanMatchGuard
} from './admin-platform-v2/guards/admin-platform-feature.guard';
import { adminDashboardRedirectGuard } from './admin-platform-v2/guards/admin-dashboard-redirect.guard';

const routes: Routes = [
    {
        path: '',
        canActivate: [authGuardFn, signupStatusGuard, userGuard],
        children: [
            {
                path: 'platform',
                loadChildren: () =>
                    import('./retailer-platform/retailer-platform.module').then(
                        (moduleImport) => moduleImport.RetailerPlatformModule
                    )
            },
            {
                // TODO: migrate all retailer related routes to this path.
                path: 'r',
                loadChildren: () =>
                    import('./retailer-platform/retailer-platform.module').then(
                        (moduleImport) => moduleImport.RetailerPlatformModule
                    )
            },
            {
                path: 'dashboard',
                canActivate: [AdminGuard, adminDashboardRedirectGuard],
                loadComponent: () =>
                    import('./dashboard/dashboard.component').then((moduleImport) => moduleImport.DashboardComponent)
            },
            // QUESTION: Why is this a top level route?
            {
                path: 'brands/:brandId/catalogs/:id',
                canActivate: [catalogRedirectionGuard],
                children: []
            },
            {
                // Must be registered before the manufacturer `path: ''` catch-all (prefix match).
                path: 'admin',
                canMatch: [adminPlatformV2CanMatchGuard],
                loadChildren: () =>
                    import('./admin-platform-v2/admin-platform-v2.module').then(
                        (moduleImport) => moduleImport.AdminPlatformV2Module
                    )
            },
            {
                path: 'admin',
                canMatch: [adminPlatformLegacyCanMatchGuard],
                loadChildren: () =>
                    import('./admin-platform/admin-platform.module').then(
                        (moduleImport) => moduleImport.AdminPlatformModule
                    )
            },
            {
                path: '',
                loadChildren: () =>
                    import('./manufacturer-platform/manufacturer-platform.module').then(
                        (moduleImport) => moduleImport.ManufacturerPlatformModule
                    )
            },
            { path: '**', redirectTo: '', pathMatch: 'full' }
        ]
    }
];

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload'
        }),
        CoreModule,
        ComponentsModule,
        AuthenticationModule,
        AuthenticatedUserModule,
        FcpToastModule.forRoot(),
        NgxEchartsModule.forRoot({ echarts: () => import('./shared/echarts/echarts') }),
        HammerModule,
        UsercentricsComponent
    ],
    declarations: [AppComponent],
    bootstrap: [AppComponent]
})
export class FcApp {}
